// ./src/contexts/PartnersContext/PartnersContext.tsx
//
// Thin context wrapper around usePartners (event partners). Mount with
// initialFilters={{ eventId: [eventId] }}. See AccommodationsContext.

import React, { createContext, useContext } from "react";

import { usePartners, UsePartnersOptions, UsePartnersReturn } from "@/hooks/usePartners";

const PartnersContext = createContext<UsePartnersReturn | null>(null);

export interface PartnersProviderProps extends UsePartnersOptions {
  children: React.ReactNode;
}

export const PartnersProvider: React.FC<PartnersProviderProps> = ({ children, ...options }) => {
  const value = usePartners(options);

  return <PartnersContext.Provider value={value}>{children}</PartnersContext.Provider>;
};

export const usePartnersContext = (): UsePartnersReturn => {
  const context = useContext(PartnersContext);

  if (!context) {
    throw new Error("usePartnersContext must be used within a <PartnersProvider>.");
  }

  return context;
};

export const useOptionalPartnersContext = (): UsePartnersReturn | null => {
  return useContext(PartnersContext);
};
